import { businessArticles } from './blogContent1';
import { complianceArticles } from './blogContent2';
import { equipmentArticles } from './blogContent3';

export const blogContent = {
  ...businessArticles,
  ...complianceArticles,
  ...equipmentArticles
};
